import dayjs from "dayjs";
import { ClockStyles } from "../../styled";

interface IProps {
  className?: string;
  serverNowMs?: number;
}

const Clock = (props: IProps) => {
  const { serverNowMs } = props;

  return (
    <ClockStyles>
      <div className="wrapper-clock">
        {serverNowMs &&
          dayjs(serverNowMs)
            .format("HH:mm:ss")
            .split("")
            .map((char, index) => (
              <div
                key={index}
                className={`${
                  [6, 7]?.includes(index) ? "second-character" : ""
                } ${[2, 5]?.includes(index) ? "colon-character" : ""}`}
              >
                {char}
              </div>
            ))}
      </div>
    </ClockStyles>
  );
};

export default Clock;
